<template>
  <div>
    <div
      :style="`font-size: ${font_size}%;font-family: tahoma;color: black;float: left;width: 100%;padding: 0 15px 0 15px;`">

      <div
        v-if="shop_logo"
        style="text-align: center;margin-bottom: 5px;">
        <img
          :src="shop_logo"
          style="width: 10.583333333mm; height: 10.583333333mm;" >
      </div>

      <div
        v-if="(shop_tax_title && shop_tax_id)"
        style="text-align: center; font-size: 0.625em;line-height: 1.2em; margin-bottom: .75em;">
        <strong>{{ $t('apps.pos.message.taxtitle') }}</strong>
      </div>

      <div style="text-align: center; font-size: 0.7em;line-height: 1.2em;">
        <strong>{{ shop_name }}</strong>
      </div>

      <div
        v-if="shop_address"
        style="text-align: center;font-size: 0.5em;line-height: 1.5em;">
        <span>
          {{ shop_address }}
        </span>
      </div>

      <div
        v-if="shop_tax_id"
        style="text-align: center;font-size: 0.5em;line-height: 1.5em;">
        <span>
          {{ $t('message.taxid') }}: {{ shop_tax_id }}
        </span>
      </div>

      <div
        v-if="shop_tel"
        style="text-align: center;font-size: 0.5em;line-height: 1.5em;">
        <span>
          {{ $t('message.tel') }}: {{ shop_tel }}
        </span>
      </div>

      <ul style="padding: 0;margin: 3mm 0 1mm 0;float: left;width: 100%;">
        <li
          v-for="(order, index) in filterOrder"
          :key="index"
          style="list-style: none;border-bottom: 1px black dotted;margin-bottom: 5px;float: left;width: 100%;">
          <p style="margin: 0;font-size: 0.5em">
            <span>
              {{ order.item }}
            </span>
            <span style="float: right;">
              {{ getNumber(order.price) }}
            </span>
          </p>
          <span
            v-for="(modifier, index_) in order.modifiers"
            :key="index_">
            <p
              v-for="(modifieroption, index__) in modifier.options"
              :key="index__"
              style="margin: 0;font-size: 0.5em">
              + {{ modifieroption.option }}
              <span style="float: right;">
                {{ getNumber(modifieroption.price) }}
              </span>
            </p>
          </span>
          <div
            v-if="order.discount > 0"
            style="float: left;width: 100%;margin-top: 0px;">
            <div style="margin: 0;font-size: 0.5em;">
              {{ $t('message.discount') }}
              <span style="float: right;">
                {{ getNumber(order.discount) }}
              </span>
            </div>
          </div>
          <div
            style="float: left;width: 100%;margin-top: 0;display: flex;justify-content: space-between;align-items: baseline;">
            <span style="margin: 0;font-size: 0.5em;">
              x{{ order.quantity }} {{ order.unit }}
            </span>
            <span style="float: right;font-size: 0.5em;">
              {{ getNumber(order.total) }}
            </span>
          </div>
        </li>
      </ul>

      <div
        v-if="total_price.discount"
        style="float: left;width: 100%;">
        <span style="font-size: 0.5em;float: left;">{{ $t('message.discounts') }}</span>
        <p style="margin: 0;font-size: 0.5em;float: right;">{{ getNumber(total_price.discount) }}</p>
      </div>

      <div
        v-for="(tax, index) in taxes"
        :key="index"
        style="float: left;width: 100%;"
      >
        <span style="font-size: 0.5em;float: left;">
          {{ tax.displayText }}
        </span>
        <p style="margin: 0;font-size: 0.5em;float: right;">
          {{ getNumber(tax.total) }}
        </p>
      </div>

      <div style="float: left;width: 100%;">
        <span style="font-size: 0.5em;float: left;">{{ $t('message.total') }}</span>
        <p style="margin: 0;font-size: 0.5em;float: right;">{{ getNumber(total_price.total) }}</p>
      </div>

      <div style="float: left;width: 100%;">
        <span style="font-size: 0.5em;float: left;">{{ $t(`apps.pos.message.${receipt_info.paymentMethod}`) }}</span>
        <p style="margin: 0;font-size: 0.5em;float: right;">{{ getNumber(receipt_info.paid) }}</p>
      </div>

      <div
        v-if="receipt_info.paymentMethod === POS_PAYMENT_METHOD.CASH"
        style="float: left;width: 100%;">
        <span style="font-size: 0.5em;float: left;">{{ $t('message.changecash', { number: null }) }}</span>
        <p style="margin: 0;font-size: 0.5em;float: right;">{{ getNumber(receipt_info.change) }}</p>
      </div>

      <div
        class="footer"
        style="border-top: dotted 1px #000;padding-top: 10px;margin: 5px 0 0 0;float: left;width: 100%;text-align: center;">
        <p class="m-0">
          <strong
            v-if="receipt_info.bi_code"
            style="font-size: 0.7em;line-height: 1.5em;">
            #{{ receipt_info.bi_code }}
          </strong>
          <strong
            v-if="receipt_info.customer"
            style="font-size: 0.7em;line-height: 1.5em;">
            {{ receipt_info.customer.customer_name }}
          </strong>
        </p>
        <p
          v-if="text_footer"
          class="m-0"
          style="font-size: 0.5em;line-height: 1.5em;">
          {{ text_footer }}
        </p>
        <p
          class="m-0"
          style="font-size: 0.5em;line-height: 1.5em;">
          {{ receipt_info.ps_code }}
          {{ date_time }}
        </p>
        <p
          class="m-0"
          style="font-size: 0.5em;line-height: 1.5em;">
          By TreeSoft.io
        </p>
      </div>

    </div>
  </div>
</template>

<script>
import { POS_PAYMENT_METHOD } from '../../../../helpers/enum'

export default {
  props: {
    shop_logo: {
      type: String,
    },
    shop_name: {
      type: String,
    },
    shop_address: {
      type: String,
    },
    shop_tax_id: {
      type: String,
    },
    shop_tax_title: {
      type: Boolean,
      default: false,
    },
    shop_tel: {
      type: String,
    },
    orders: {
      type: Array,
    },
    total_price: {
      type: Object,
    },
    receipt_info: {
      type: Object,
    },
    date_time: {
      type: String,
    },
    text_footer: {
      type: String,
    },
    font_size: {
      type: Number,
      default: () => 100,
    },
  },

  data () {
    return {
      POS_PAYMENT_METHOD: POS_PAYMENT_METHOD,
    }
  },

  computed: {
    filterOrder () {
      return this.orders.map((order) => {
        const includeDiscount = true
        const includeTax = false
        const orderTotal = this.getTotal([order], includeDiscount, includeTax)
        return {
          ...order,
          discount: orderTotal.discount,
          total: orderTotal.payment,
        }
      })
    },
    taxes() {
      return this.getTaxesByOrders(this.filterOrder)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/custom/print/pos/Receipt.vue